import styled from 'styled-components';

export const AccountActivationWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundColor};
`;
